export const environment = {
    apiUrl: 'https://admin.zehentmoar.at',
    stripeKey:
        'pk_live_51Qrz3VHXyankQvivKZJLe2m0nTYoaKf0pC341SUcqIqtD9DTb8IOve8oighZx6ox6SoPSmzkQRuwJRTOCz73vx7x00UD8ewIop',
};
